var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import cn from "classnames";
import { Sheet } from "@react-md/sheet";
import { bem } from "@react-md/utils";
import { LayoutNavigationHeader, } from "./LayoutNavigationHeader";
import { useLayoutConfig } from "./LayoutProvider";
import { LayoutTree } from "./LayoutTree";
import { isPersistentLayout, isTemporaryLayout, isToggleableLayout, } from "./utils";
var styles = bem("rmd-layout-navigation");
/**
 * The container for the main navigation within the `Layout` that renders
 * differently depending on the current layout type.
 */
export var LayoutNavigation = forwardRef(function LayoutNavigation(_a, ref) {
    var propId = _a.id, _b = _a["aria-label"], ariaLabel = _b === void 0 ? "Navigation" : _b, ariaLabelledby = _a["aria-labelledby"], className = _a.className, children = _a.children, _c = _a.mini, mini = _c === void 0 ? false : _c, propHeader = _a.header, headerProps = _a.headerProps, headerTitle = _a.headerTitle, headerTitleProps = _a.headerTitleProps, closeNav = _a.closeNav, closeNavProps = _a.closeNavProps, treeProps = _a.treeProps, props = __rest(_a, ["id", "aria-label", "aria-labelledby", "className", "children", "mini", "header", "headerProps", "headerTitle", "headerTitleProps", "closeNav", "closeNavProps", "treeProps"]);
    var _d = useLayoutConfig(), baseId = _d.baseId, layout = _d.layout, isNonMiniVisible = _d.visible, hideNav = _d.hideNav;
    var visible = mini || isNonMiniVisible;
    var id = propId || baseId + "-" + (mini ? "mini-" : "") + "nav-container";
    var isTemporary = !mini && isTemporaryLayout(layout);
    var isPersistent = mini || isPersistentLayout(layout);
    var isToggleable = !mini && isToggleableLayout(layout);
    var floating = layout === "floating";
    var header = propHeader;
    if (!mini && typeof header === "undefined") {
        header = (React.createElement(LayoutNavigationHeader, __assign({ closeNav: closeNav, closeNavProps: closeNavProps, title: headerTitle, titleProps: headerTitleProps }, headerProps)));
    }
    return (React.createElement(Sheet, __assign({}, props, { key: layout, id: id, ref: ref, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, role: !isPersistent ? "dialog" : "none", visible: visible, onRequestClose: hideNav, 
        // do not want to portal for the other types so that logical tab order
        // is preserved
        portal: isTemporary, overlay: isTemporary, disableScrollLock: !isTemporary, disableTabFocusWrap: isToggleable, disableNestedDialogFixes: mini, className: cn(styles({
            mini: mini,
            floating: floating,
            "header-offset": layout === "clipped" || floating,
        }), className) }),
        header,
        treeProps && React.createElement(LayoutTree, __assign({}, treeProps, { mini: mini })),
        children));
});
/* istanbul ignore next */
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        LayoutNavigation.propTypes = {
            id: PropTypes.string,
            "aria-label": PropTypes.string,
            "aria-labelledby": PropTypes.string,
            className: PropTypes.string,
            children: PropTypes.node,
            treeProps: PropTypes.object,
            header: PropTypes.node,
            headerProps: PropTypes.object,
            headerTitle: PropTypes.node,
            headerTitleProps: PropTypes.object,
            closeNav: PropTypes.node,
            closeNavProps: PropTypes.object,
        };
    }
    catch (error) { }
}
//# sourceMappingURL=LayoutNavigation.js.map